<template>
  <div class="row mt-1 m-0 mb-0 pb-0">
    <div class="table-responsive mx-0 px-1 mb-0 pb-0">

      <div v-for="(team, key, index) in teams">
        <div :id="'team' + index">
        <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover mt-2 mb-1">
          <thead>
              <tr>
                <th scope="col" class="event-id-column" colspan="2" nowrap>{{ team.name }}</th>
              </tr>
          </thead>
          <tbody>
            <template v-if="user && user.email">
              <tr v-for="entry in getEntriesByTeam(team.team_id)" data-bs-toggle="modal" data-bs-target="#editEntryModal" @click="openEditEntryForm(entry.event_id, entry.entry_id)">
                <td width="60px" style="text-align: center;">{{ entry.event_id }}</td>
                <td><span v-if="team.team_id != entry.team_id_1"><TeamLabelComponent :teamId="entry.team_id_1"/></span> <img src="/avator/avator-man-1-2-48.png" width="24" height="24">{{ entry.player_name_1 }} <span v-if="team.team_id != entry.team_id_2"><TeamLabelComponent :teamId="entry.team_id_2"/></span><img src="/avator/avator-woman-48.png" width="24" height="24" v-if="entry.player_name_2 && entry.player_name_2 != ''"> {{ entry.player_name_2 }}</td>
              </tr>
            </template>
            <template v-if="!user || !user.email">
              <tr v-for="entry in getEntriesByTeam(team.team_id)">
                <td width="60px" style="text-align: center;">{{ entry.event_id }}</td>
                <td><span v-if="team.team_id != entry.team_id_1"><TeamLabelComponent :teamId="entry.team_id_1"/></span> <img src="/avator/avator-man-1-2-48.png" width="24" height="24">{{ entry.player_name_1 }} <span v-if="team.team_id != entry.team_id_2"><TeamLabelComponent :teamId="entry.team_id_2"/></span><img src="/avator/avator-woman-48.png" width="24" height="24" v-if="entry.player_name_2 && entry.player_name_2 != ''"> {{ entry.player_name_2 }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      </div>
      <div>
        <template v-if="user && user.email">
          <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover mt-2 mb-1">
            <thead>
                <tr>
                  <th scope="col" class="event-id-column" colspan="2" nowrap>チーム未定</th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="entry in getEmptyTeamEntries()" data-bs-toggle="modal" data-bs-target="#editEntryModal" @click="openEditEntryForm(entry.event_id, entry.entry_id)">
                <td width="60px" style="text-align: center;">{{ entry.event_id }}-{{ entry.entry_id }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>

  <AffiliateComponent />
  <hr>
  <span style="display: flex;justify-content: center; font-size: 10pt; color:darkgrey">Avator icons provided by&nbsp; <a target="_blank" href="https://icons8.com">Icons8</a></span>

  <!-- fab -->
  <div class="fab-container">
    <div class="btn-group-vertical btn-group-lg buttons" role="group" aria-label="Vertical radio toggle button group">
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio1" autocomplete="off" @click="scrollTo(-1)">
      <label class="btn btn-outline-primary" for="vbtn-radio1"><font-awesome-icon :icon="['fas', 'chevron-up']" /></label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio2" autocomplete="off" @click="scrollTo(1)">
      <label class="btn btn-outline-primary" for="vbtn-radio2"><font-awesome-icon :icon="['fas', 'chevron-down']" /></label>
    </div>
  </div>

  <div class="text-center" v-if="isLoading">
    <div class="spinner-border spinner" role="status">
        <span class="sr-only">Loading...</span>
    </div>
  </div>

  <EditEntryFormComponent :selectedEntryId="selectedEntryId" :selectedEntry="selectedEntry" @doReload="doReload"></EditEntryFormComponent>
  <FooterComponent @reloadRank="reloadRank"></FooterComponent>
</template>
  
<script setup>
import EditEntryFormComponent from '@/components/EditEntryFormComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import AffiliateComponent from '@/components/AffiliateComponent.vue'
import TeamLabelComponent from '@/components/TeamLabelComponent.vue'
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ref as fbRef, getDatabase, child, get } from "firebase/database"
import { getAuth } from "firebase/auth";
const auth = getAuth();
const user = auth.currentUser;
// const role = ref();
const route = useRoute()
const db = getDatabase();
const dbRef = fbRef(db);
const isLoading = ref()
const teams = ref([])
const currentScrollPosition = ref();
const maxScrollPosition = ref();
const selectedEntryId = ref();
const selectedEntry = ref([]);

onMounted(() => {
  teams.value = getTeams();
  currentScrollPosition.value = 0;
  maxScrollPosition.value = Object.keys(teams.value).length - 1;
});

const doReload = async () => {
  isLoading.value = true;
  await fetchEntries();
  isLoading.value = false;
}

const reloadRank = async () => {
  isLoading.value = true;
  await fetchEntries();
  isLoading.value = false;
}

const fetchEntries = async () => {
    await get(child(dbRef, '/2026-summer/entries')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('entries', JSON.stringify(snapshot.val()));
        } else {
            console.log('No entry data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const getTeams = () => {
  return JSON.parse(localStorage.getItem("teams"));
};

const getEntriesByTeam = (team_id) => {
  if (!team_id) { return; }
  const allEntries = ref([]);
  allEntries.value = JSON.parse(localStorage.getItem("entries"));
  return Object.fromEntries(
    Object.entries(allEntries.value).filter(([key, value]) =>
      (team_id == value.team_id_1 || team_id == value.team_id_2)).sort(function (a, b) {
        if (a[1].event_id < b[1].event_id) { return -1 }
        if (a[1].event_id > b[1].event_id) { return 1 }
        if (a[1].entry_id < b[1].entry_id) { return -1 }
        if (a[1].entry_id > b[1].entry_id) { return 1 }
        return 0
      })
  );
};

const getEmptyTeamEntries = () => {
  const allEntries = ref([]);
  allEntries.value = JSON.parse(localStorage.getItem("entries"));
  return Object.fromEntries(
    Object.entries(allEntries.value).filter(([key, value]) =>
      ("" == value.team_id_1 && "" == value.team_id_2)).sort(function (a, b) {
        if (a[1].event_id < b[1].event_id) { return -1 }
        if (a[1].event_id > b[1].event_id) { return 1 }
        if (a[1].entry_id < b[1].entry_id) { return -1 }
        if (a[1].entry_id > b[1].entry_id) { return 1 }
        return 0
      })
  );
};

const scrollTo = (direction) => {
  if (currentScrollPosition.value >= maxScrollPosition.value && direction == 1) {
    currentScrollPosition.value = 0;
  } else if (currentScrollPosition.value <= 0 && direction == -1) {
    currentScrollPosition.value = maxScrollPosition.value;
  } else {
    currentScrollPosition.value = currentScrollPosition.value + direction;
  }
  window.location.href = '#team' + currentScrollPosition.value;
};

const openEditEntryForm = (event_id, entry_id) => {
  selectedEntryId.value = event_id + "-" + entry_id;
  get(child(dbRef, '/2026-summer/entries/' + event_id + "-" + entry_id))
    .then((snapshot) => {
        if (snapshot.exists()) {
          selectedEntry.value = snapshot.val();
        } else {
          console.warn("Not found - entry:" + event_id + "-" + entry_id)
        }
    });
}

</script>
  
<style scoped>
#result-tbl {
  border-color: #dee2e6;
}

.rank-column {
  width: 25px;
}

th.rank-column {
  background-color: #e9ecef;
}

.event-id-column {
  background-color: #a3cfbb;
  text-align: center;
}

th.point-clmn {
  background-color: #e9ecef;
}

.team-column {
  border-right: none;
  width: 50px;
}

.player-column {
  text-align: left;
  border-left: none;
}

tr.boundary {
  border-top: 2px solid #198754;
}

.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}

.fab-container {
  position: fixed;
  bottom: 80px;
  right: 20px;
  /* left: 50%; */
  cursor: pointer;
  z-index: 8;
}

.buttons {
  box-shadow: 5px 5px 5px #aaaaaa;
  background-color: #fff;
}

#vbtn-radio1 {
  background-color: white;
}
</style>